"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.inputStyles = void 0;
var _utils = require("@amzn/stencil-design-tokens/js/web/utils");
var _stencilReactThemeDefault = require("@amzn/stencil-react-theme-default");
var _constants = require("../_form/constants");
var _TextCSS = require("../text/TextCSS");
var _text = require("../text");
var _utils2 = require("../utils");
const inputStyles = _ref => {
  let {
    error,
    props,
    warning,
    borderRadius
  } = _ref;
  const placeholderStyles = {
    ...(0, _TextCSS.getTextVariantStyles)(_text.TextVariant.BodyHint),
    color: (0, _utils.token)('color.text.secondary')
  };
  const BORDER_COLOR = (0, _utils2.getColor)((0, _utils.token)('color.input.border-default'), error, warning);
  const BORDER_COLOR_FOCUS = (0, _utils2.getColor)((0, _utils.token)('color.input.selected.border-default'), error, warning);
  const OUTER_COLOR_FOCUS = (0, _utils2.getColor)((0, _utils.token)('color.input.selected.border-default'), error, warning);
  const borderRadiusStyle = borderRadius || _constants.INPUT_BORDER_RADIUS;
  const outlineStyle = (0, _utils2.addOutline)(_constants.INPUT_OUTLINE_WIDTH, 0, OUTER_COLOR_FOCUS, {
    width: 1,
    color: (0, _utils.token)('color.input.bg-default')
  });
  const styles = {
    transition: 'border .2s, box-shadow .2s',
    boxSizing: 'border-box',
    margin: '0px',
    padding: "".concat((0, _utils2.px)(_constants.INPUT_PADDING_VERTICAL_DEFAULT), " ").concat((0, _utils2.px)(_constants.INPUT_PADDING_HORIZONTAL_DEFAULT)),
    fontSize: (0, _utils.token)('text.size.200'),
    lineHeight: (0, _utils.token)('text.lineHeight.200'),
    border: "".concat(_constants.INPUT_BORDER_WIDTH, "px solid ").concat(BORDER_COLOR),
    zIndex: 1,
    boxShadow: 'none',
    ':focus': {
      borderColor: BORDER_COLOR_FOCUS,
      ...outlineStyle.focus
    },
    '::placeholder': placeholderStyles,
    '::-moz-placeholder': {
      /* Firefox 19+ */...placeholderStyles,
      opacity: 1
    },
    color: (0, _utils.token)('color.text.primary'),
    backgroundColor: (0, _utils.token)('color.input.bg-default'),
    ...(0, _utils2.cssValueProp)(_stencilReactThemeDefault.fontWeightPropAdapter, props.fontWeight, 'fontWeight'),
    ...(0, _utils2.cssValueProp)(_stencilReactThemeDefault.fontFamilyPropAdapter, props.font || 'primary', 'fontFamily'),
    ...(0, _utils2.cssValueProp)(_stencilReactThemeDefault.colorPropAdapter, props.color, 'color'),
    ...(0, _utils2.cssValueProp)(_stencilReactThemeDefault.colorPropAdapter, props.backgroundColor, 'backgroundColor'),
    ...(0, _utils2.getBorderRadiusStyle)(_stencilReactThemeDefault.radiusPropAdapter, borderRadiusStyle || 0)
  };
  return styles;
};
exports.inputStyles = inputStyles;